const PdfReportActionTypes = {
  FETCH_PDF_REPORT_REQUEST: 'FETCH_PDF_REPORT_REQUEST',
  FETCH_PDF_REPORT_SUCCESS: 'FETCH_PDF_REPORT_SUCCESS',
  FETCH_PDF_REPORT_FAILURE: 'FETCH_PDF_REPORT_FAILURE'
}

export default PdfReportActionTypes